import { render } from "./RecapStat.vue?vue&type=template&id=35dfd7f1&scoped=true"
const script = {}

import "./RecapStat.vue?vue&type=style&index=0&id=35dfd7f1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\pc\\Documents\\projets\\school_app_front_novation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35dfd7f1"]])

export default __exports__